import React, { FC, ReactElement, useCallback } from 'react';
import { HOT_JAR_TAG } from 'b2b-apps/shop/analytics/types/types';
import { tagHotJarRecording } from 'b2b-apps/shop/analytics/utils/analytics';

export type WithFlyoutProps = {
  onFlyoutOpen: () => void;
}
type WithFlyoutType<P> = (Component: FC<P & WithFlyoutProps>) => FC<P>;

export const withFlyout = <P extends Record<string, any>>(
  hotjarTag: HOT_JAR_TAG,
): WithFlyoutType<P> => (Component) => {
    const WithFlyout = (props: P): ReactElement => {
      const handleFlyoutOpen = useCallback(
        () => {
          tagHotJarRecording(hotjarTag);
        },
        [],
      );


      return <Component {...props} onFlyoutOpen={handleFlyoutOpen} />;
    };

    return WithFlyout;
  };
